const responseMenuUserCompany = {
  "payload": {
    "empresaId": 1,
    "empresaNombre": "Empresa Demo",
    "empresaLogo": "https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png",
    "empresaDescripcion": "Empresa de demostraci�n"
  }
};

export const service = {
  getMenuUserCompany: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseMenuUserCompany }), 1000);
  }),
}
